import dynamic from 'next/dynamic';

export const SearchFieldDesktop = dynamic(() => import('./SearchField/SearchFieldDesktop'), { ssr: false });
export const SearchFieldMobile = dynamic(() => import('./SearchField/SearchFieldMobile'), { ssr: false });
export const SearchResultsDesktop = dynamic(() => import('./SearchResultsDesktop/SearchResultsDesktop'), { ssr: false });
export const SearchResultsMobile = dynamic(() => import('./SearchResultsMobile/SearchResultsMobile'), { ssr: false });

export { default as SearchPageSuggestedCategories } from './SearchPageSuggestedCategories/SearchPageSuggestedCategories';
